/* eslint-disable no-unreachable -- temporarily hide Haifa Cafe ad */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import { useDispatch, useSelector } from 'react-redux';
import { setModalOpen, setModalRestaurant } from '../../redux/features/infoModal/infoModalSlice';

const FEATURED_BUSINESS = {
    restaurantId: '986ef69e44591c47',
    name: 'Haifa Cafe',
    tagline: 'Where Tradition Meets Community',
    imageUrl: 'https://haifacafe.ca/assets/images/hero.webp',
};

const FeaturedBusinessBanner = () => {
    const [dismissed, setDismissed] = useState(false);
    const allRestaurants = useSelector((state) => state.restaurantsReducer.restaurants);
    const dispatch = useDispatch();

    // Temporarily hide Haifa Cafe ad
    return null;

    if (dismissed) return null;

    const handleClick = () => {
        const restaurant = allRestaurants.find((r) => r.id === FEATURED_BUSINESS.restaurantId);
        if (restaurant) {
            dispatch(setModalRestaurant(restaurant));
            dispatch(setModalOpen(true));
        }
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 'calc(72px + env(safe-area-inset-bottom) + 8px)',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 999,
                width: 'calc(100vw - 24px)',
                maxWidth: 400,
            }}
        >
            <Card
                elevation={6}
                sx={{
                    borderRadius: 3,
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <CardActionArea onClick={handleClick} sx={{ display: 'flex', alignItems: 'stretch', height: 90 }}>
                    <CardMedia
                        component="img"
                        image={FEATURED_BUSINESS.imageUrl}
                        alt={FEATURED_BUSINESS.name}
                        sx={{ width: 100, objectFit: 'cover' }}
                    />
                    <Box sx={{ flex: 1, px: 1.5, py: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.25 }}>
                            <StarIcon sx={{ color: '#FFB800', fontSize: 16 }} />
                            <Typography variant="caption" sx={{ color: '#00C2FF', fontWeight: 'bold', fontSize: '0.65rem' }}>
                                Featured
                            </Typography>
                            <Chip
                                label="Ad"
                                size="small"
                                sx={{
                                    ml: 'auto',
                                    mr: 3,
                                    fontSize: '0.6rem',
                                    height: 16,
                                    bgcolor: 'rgba(0,0,0,0.06)',
                                    color: 'text.secondary',
                                }}
                            />
                        </Box>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
                            {FEATURED_BUSINESS.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.3, mt: 0.25 }}>
                            {FEATURED_BUSINESS.tagline}
                        </Typography>
                    </Box>
                </CardActionArea>
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setDismissed(true);
                    }}
                    sx={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        bgcolor: 'rgba(255,255,255,0.85)',
                        '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
                        width: 22,
                        height: 22,
                    }}
                >
                    <CloseIcon sx={{ fontSize: 14 }} />
                </IconButton>
            </Card>
        </Box>
    );
};

export default FeaturedBusinessBanner;
